/* eslint-disable object-curly-newline */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  getGuestById,
  getReservationById,
  setReservationCode,
} from '../../store/widgetSlice';

import RecognizeModal from '../modals/RecognizeModal';
import VerifyModal from '../modals/VerifyModal';
import CardModal from '../modals/CardModal';

import BaseDataTable from '../common/BaseDataTable';
import StatusIcon from '../common/StatusIcon';

export default function SummaryTable({ rows }) {
  const dispatch = useDispatch();
  const [identityOpen, setIdentityOpen] = useState(false);
  const [addressOpen, setAddressOpen] = useState(false);
  const [cardOpen, setCardOpen] = useState(false);

  const handleIdentityOpen = (reservationCode) => () => {
    dispatch(setReservationCode(reservationCode));
    setIdentityOpen(true);
  };

  const handleIdentityClose = () => {
    setIdentityOpen(false);
  };

  const handleAddressOpen = (reservationCode, reservationId, guestId) => () => {
    dispatch(getReservationById({ reservationId }));
    dispatch(getGuestById({ guestId }));
    dispatch(setReservationCode(reservationCode));
    setAddressOpen(true);
  };

  const handleAddressClose = () => {
    setAddressOpen(false);
  };

  const handleCardOpen = (reservationCode) => () => {
    dispatch(setReservationCode(reservationCode));
    setCardOpen(true);
  };

  const handleCardClose = () => {
    setCardOpen(false);
  };

  const columns = [
    {
      field: 'reservationCode',
      headerName: 'Code',
      width: 150,
      sortable: false,
    },
    {
      field: 'identityVerified',
      headerName: 'Identity',
      width: 110,
      sortable: false,
      renderCell: ({ value, row }) => (
        <button className="grwidget__status-button" type="button" onClick={handleIdentityOpen(row.reservationCode)}>
          <div className="grwidget__status-item">
            <span className="grwidget__status-icon">
              <StatusIcon status={(row && row.status === 'P') ? 2 : value} />
            </span>
          </div>
        </button>
      ),
    },
    {
      field: 'addressVerified',
      headerName: 'Address',
      width: 110,
      sortable: false,
      renderCell: ({ value, row }) => (
        <button
          className="grwidget__status-button"
          type="button"
          onClick={handleAddressOpen(row.reservationCode, row.id, row.guestId)}
        >
          <div className="grwidget__status-item">
            <span className="grwidget__status-icon">
              <StatusIcon status={value} />
            </span>
          </div>
        </button>
      ),
    },
    {
      field: 'cardVerified',
      headerName: 'Card',
      width: 110,
      sortable: false,
      renderCell: ({ value, row }) => (
        <button className="grwidget__status-button" type="button" onClick={handleCardOpen(row.reservationCode)}>
          <div className="grwidget__status-item">
            <span className="grwidget__status-icon">
              <StatusIcon status={value} />
            </span>
          </div>
        </button>
      ),
    },
    {
      field: 'firstName',
      headerName: 'First Name',
      width: 130,
      sortable: false,
    },
    {
      field: 'lastName',
      headerName: 'Last Name',
      width: 130,
      sortable: false,
    },
    {
      field: 'city',
      headerName: 'City',
      width: 130,
      sortable: false,
    },
    {
      field: 'state',
      headerName: 'State',
      width: 130,
      sortable: false,
    },
  ];

  return (
    <>
      <RecognizeModal hideDefaultButton externalOpen={identityOpen} externalHandleClose={handleIdentityClose} />
      <VerifyModal hideDefaultButton externalOpen={addressOpen} externalHandleClose={handleAddressClose} />
      <CardModal hideDefaultButton externalOpen={cardOpen} externalHandleClose={handleCardClose} />
      <div className="summary-table-container">
        <BaseDataTable
          rows={rows}
          columns={columns}
          style={{ height: '25vh', width: '100%' }}
        />
      </div>
    </>
  );
}
